import { dashboardQueryOptions, useGetTotalIncomeQuery } from "@RTKQuery/admin/dashboard/dashboard";
import style from "./TotalAmounts.module.scss";
import { useAppSelector } from "store/hooks";
import { AnalyticsStatus } from "../AnalyticsStatus/AnalyticsStatus";

export function TotalAmounts() {
    const { activeEndDate, activeStartDate } = useAppSelector(state => state.dashboardAdminPage);

    const { currentData: data, isError, refetch } = useGetTotalIncomeQuery({
        end_date: activeEndDate,
        start_date: activeStartDate
    }, dashboardQueryOptions);

    if (isError || !data) return <div className={style.flexBox}>
        <AnalyticsStatus error={isError}
            message={isError ? "Не вдалося завантажити дохід і витрати." : "Завантаження підсумків…"}
            retry={isError ? refetch : undefined} />
    </div>;

    return (
        <div className={style.flexBox}>
            <div className={style.container}>
                <p className={style.label}>Загальний дохід</p>
                <div className={style.value}>
                    <p title={String(data?.earn_usd || 0)} className="text-[#1178D6] truncate min-w-0 max-w-full">$ {data?.earn_usd || 0}</p>
                    <p>/</p>
                    <p title={String(data?.earn_ua || 0)} className="truncate min-w-0 max-w-full">{data?.earn_ua || 0} ₴</p>
                </div>
            </div>
            <div className={style.container}>
                <p className={style.label}>Загальні витрати</p>
                <div className={style.value}>
                    <p title={String(data?.cost_usd || 0)} className="text-[#1178D6] truncate min-w-0 max-w-full ">$ {data?.cost_usd || 0}</p>
                    <p>/</p>
                    <p title={String(data?.cost_ua || 0)} className="truncate min-w-0 max-w-full">{data?.cost_ua || 0} ₴</p>
                </div>
            </div>
            <div className={style.container}>
                <p className={style.label}>Дохід з урахуванням всіх витрат</p>
                <div className={style.value}>
                    <p title={String(data?.result_earn_usd || 0)} className="text-[#1178D6] truncate min-w-0 max-w-full">$ {data?.result_earn_usd || 0}</p>
                    <p>/</p>
                    <p title={String(data?.result_earn_ua || 0)} className="truncate min-w-0 max-w-full">{data?.result_earn_ua || 0} ₴</p>
                </div>
            </div>
        </div>
    )
}
